var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatistics({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1237 23.8061L15.8605 20.0167C15.6253 19.8073 15.2966 19.7395 14.9988 19.8398C14.3765 20.0467 13.7251 20.1523 13.0607 20.1523C10.2549 20.1523 7.80447 18.2545 7.1024 15.538C7.00285 15.1501 6.65264 14.8788 6.2518 14.8788H0.880533C0.347332 14.8788 -0.0656351 15.3513 0.010185 15.8822C0.931978 22.3246 6.54272 27.1835 13.0607 27.1835C15.5214 27.1835 17.9221 26.5011 20.0035 25.2094C20.5063 24.8986 20.5599 24.1918 20.1237 23.8061ZM22.9106 5.24274C20.4112 2.43007 16.821 0.816467 13.0607 0.816467C6.55133 0.816467 0.940591 5.67446 0.00936464 12.116C-0.0681546 12.6477 0.345633 13.1211 0.878834 13.1211H6.25784C6.65393 13.1211 7.02014 12.7978 7.12115 12.4148C7.83101 9.72344 10.2673 7.84775 13.0608 7.84775C14.5966 7.84775 16.072 8.42214 17.1981 9.44237C17.8644 10.046 18.905 9.97768 19.5771 9.38055L22.8377 6.48392C23.1997 6.16102 23.2338 5.60526 22.9106 5.24274Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5144 2.88719C25.1978 2.53376 24.642 2.51712 24.2875 2.83258L17.0303 9.29246C18.4278 10.4772 19.2132 12.1989 19.2132 14C19.2132 15.5215 18.6527 16.9863 17.6363 18.1186C17.321 18.4698 17.3801 19.0188 17.7327 19.3326L24.2884 25.1683C24.6482 25.4893 25.2038 25.4603 25.5287 25.097C28.2572 22.0432 30.0002 18.1018 30.0002 14C30.0002 9.89106 28.252 5.9432 25.5144 2.88719Z",
    fill: "url(#paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 11.5664,
    y1: 27.1835,
    x2: 11.5664,
    y2: 0.816467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53AFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9D4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 23.5152,
    y1: 25.3906,
    x2: 23.5152,
    y2: 2.60829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FA2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#359BFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatistics);
export default __webpack_public_path__ + "static/media/statistics.3553b6e0fbf26c5dad16b3ae397447b1.svg";
export { ForwardRef as ReactComponent };